export const Compass = () => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92486 23 12C23 18.0751 18.0751 23 12 23C5.92486 23 1 18.0751 1 12ZM12 2.53488C6.77255 2.53488 2.53488 6.77255 2.53488 12C2.53488 17.2274 6.77256 21.4651 12 21.4651C17.2274 21.4651 21.4651 17.2274 21.4651 12C21.4651 6.77256 17.2274 2.53488 12 2.53488ZM17.6073 6.39243C17.8496 6.63471 17.9019 7.00826 17.7356 7.30779L14.1178 13.8198C14.0483 13.9451 13.945 14.0484 13.8197 14.1179L7.30771 17.7357C7.00818 17.902 6.63463 17.8497 6.39234 17.6074C6.15006 17.3651 6.09774 16.9916 6.26414 16.6921L9.88194 10.1801C9.95154 10.0548 10.0548 9.95154 10.1801 9.88194L16.692 6.26422C16.9915 6.09782 17.365 6.15014 17.6073 6.39243ZM11.1172 11.1172L8.91033 15.0895L12.8826 12.8827L15.0894 8.91039L11.1172 11.1172Z"
        fill="#55565C"
      />
    </svg>
  )
}
